import { cn } from "@/lib/utils";

const VARIANT_CLASS = {
  planned: "app-badge-planned",
  completed: "app-badge-completed",
  recovery: "app-badge-recovery",
  "high-load": "app-badge-load",
  load: "app-badge-load",
  pb: "app-badge-pb",
  "personal-best": "app-badge-pb",
  connected: "app-badge-connected",
  brand: "app-badge-brand",
  neutral: "app-badge-neutral",
};

export const StatusBadge = ({ variant = "neutral", className, children, ...props }) => (
  <span className={cn("app-badge", VARIANT_CLASS[variant] || VARIANT_CLASS.neutral, className)} {...props}>
    {children}
  </span>
);
